import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { type Observable, map } from 'rxjs';

import type { ApiEnvelope } from '../http/api-envelope';
import type { CreateWorkspaceResponse } from './workspaces.contract';
import { type NewWorkspace, toCreatePayload } from './workspaces.mapper';

export interface CreatedWorkspace {
  readonly id: string | null;
}

/**
 * Transport for creating a workplace. Doubles as its DI token.
 *
 * Lives in core (not the company feature) because the dialog is opened from
 * the application shell and the welcome screen — features must not import
 * each other, and layouts must not import features.
 */
@Injectable()
export abstract class WorkspacesApi {
  abstract create(workspace: NewWorkspace): Observable<CreatedWorkspace>;
}

/**
 * `POST /workspaces` — React `AddCompany` / Go `EnterpriseHQCreate`.
 */
@Injectable()
export class HttpWorkspacesApi extends WorkspacesApi {
  private readonly http = inject(HttpClient);

  override create(workspace: NewWorkspace): Observable<CreatedWorkspace> {
    return this.http
      .post<ApiEnvelope<CreateWorkspaceResponse>>('/workspaces', toCreatePayload(workspace))
      .pipe(map((response) => ({ id: response.data?.id ?? null })));
  }
}
